// Module
var code = "<react-component name=\"EventDefaultsList\"></react-component>\n";
// Exports
module.exports = code;